"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionState = exports.SessionEventCode = exports.SessionEvent = void 0;
const state_1 = require("../state");
const EventReceived = 'eventReceived';
exports.SessionEvent = Object.assign(Object.assign({}, state_1.StateEvent), { EventReceived });
var SessionEventCode;
(function (SessionEventCode) {
    SessionEventCode["AuthenticationFailed"] = "authenticationFailed";
    SessionEventCode["AuthenticationSucceeded"] = "authenticationSucceeded";
    SessionEventCode["Reconnecting"] = "reconnecting";
    SessionEventCode["RefreshFailed"] = "refreshFailed";
    SessionEventCode["RefreshSucceeded"] = "refreshSucceeded";
})(SessionEventCode || (exports.SessionEventCode = SessionEventCode = {}));
var SessionState;
(function (SessionState) {
    SessionState["Opened"] = "Opened";
    SessionState["Closed"] = "Closed";
    SessionState["Pending"] = "Pending";
})(SessionState || (exports.SessionState = SessionState = {}));
